import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(addToCartButtonStyles, {
    button: {
        variant: "primary",
        css: css`
            ${props => props.theme?.button?.primary?.css}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [null, "200px", null, "260px"], properties: ["min-width"] }],
                    mediaOptions.min,
                )}
			margin-right: 1em;
        `,
    },
});
